module.exports = __webpack_public_path__ + "img/1.61355e34.png";